import React from 'react';
import styled from '../theme/styled.js';
import { token } from '../theme/tokens.js';

const InlineListItems = styled.span(({ theme }) => ({
    fontWeight: 'normal',
    fontFamily: token(theme, 'font.body'),
    fontSize: token(theme, 'fontSize.small'),
    color: token(theme, 'color.textTertiary'),
}));

const InlineList = ({ items, separator = '·' }) => <InlineListItems>
    {items.map((item, index) =>
        <React.Fragment key={index}>
            {index > 0 && `  ${separator}  `}
            {item}
        </React.Fragment>,
    )}
</InlineListItems>;

export default InlineList;
